import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { isBrowser, isMobile } from "react-device-detect";
import LoadingGif from './Loading-gif';
import ButtonLinkGenderPage from './Button-link-gender-page'
import { connect } from 'react-redux';
import { 
  sortArgsForFilter, 
  keywordsForFilter, 
  actionSizeForFilter,
  oneKeywordForFilter, 
  fetchDataApi,
  actionPriceRangeFilter,
  actionFillFilters
} from '../actions/DataFetchingActions';
import { 
  Container,
  Row,
  Col
} from 'reactstrap';
import '../style/shimmer.css';

class  shopByBrand extends Component {

    constructor(props){
      super(props);
      this.state = {
       categories :[]
      };
    };
  

  componentDidMount() {
    fetch(`/api/shopbybrand`)
      .then(response => {        
        return response.json();
      })
      .then((data) => {        
        this.setState({
          categories: data.map(item=>({
            catname: item._id,            
            img:item.catimg,           
          }))
        });
      });
  }   

  render() {
    const {categories} = this.state;
    const color =()=> { return '#'+(Math.random() * 0xFFFFFF << 0).toString(16).padStart(6, '0')+"44" };
        
const ShimmerCards = () =>{
  return(
    <div className="d-flex p-2">
    <div className="profilePic br animate w100 mx-2 my-2" style={{height:'100px', width:'100px'}}/>
    <div className="profilePic br animate w100 mx-2 my-2" style={{height:'100px', width:'100px'}}/>
    <div className="profilePic br animate w100 mx-2 my-2" style={{height:'100px', width:'100px'}}/>
    <div className="profilePic br animate w100 mx-2 my-2" style={{height:'100px', width:'100px'}}/>
    <div className="profilePic br animate w100 mx-2 my-2" style={{height:'100px', width:'100px'}}/>
</div>
  )
}
    const cards = categories.map(x => { 
    return(  
      x.catname == null || x.catname == "" ? "":    
      <Link to={`/brand/${x.catname}`} key={x.catname} className="col-md-3 col-6">
         <div className=" d-inline  shadow-sm  mx-2 mx-md-3 mb-3 text-left d-flex" 
            style = {{width: isMobile?'100%':'100%',
            color:'#000',               
            borderRadius:'30px',
            padding:'10px',        
            background: 'linear-gradient(49deg,'+color()+', '+color()+') ',
            alignItems: 'center', 
            justifyContent:'left'}}> <span style={{padding:'10px 20px', borderRadius:'30px',marginRight:'10px', background:'#fff', color:'#000', fontWeight:'bolder'}}>{x.catname.substr(0,1).toUpperCase()}</span>
          {x.catname}   
          </div>
      </Link>      
      )
    
    })
    return(
      <div className="container" style = {{display:'flex',
                     flexFlow:'row wrap', 
                      background:'#ffff0',
                      justifyContent: 'left'}}>{categories.length>1  ? cards:<ShimmerCards/>}</div>
    )
  }
} 

export default shopByBrand;


// WEBPACK FOOTER //
// ./src/components/shop-by-brand.js